import * as moment from 'moment-timezone';

export module DateHelpers {

  function invalidDate(date: any): boolean {
    return (!date || !moment(date).isValid());
  }

  export function fromISOString(dateString: string): Date {
    if (!dateString || !moment(dateString, 'YYYY-MM-DDTHH:mm:ss.sssZ').isValid()) {
      return undefined;
    }
    return moment(dateString).toDate();
  }

  export function toISOString(date: Date): string {
    if (invalidDate(date)) {
      return undefined;
    }
    return moment(date).toISOString();
  }

  export function midnight(date: Date): Date {
    if (invalidDate(date)) {
      return undefined;
    }
    return moment(date).startOf('day').toDate();
  }

  export function endOfDay(date: Date): Date {
    if (invalidDate(date)) {
      return undefined;
    }
    return moment(date).endOf('day').toDate();
  }


}
